const state = {
  windowWidth: window.innerWidth,
  activeRoute: ''
}

const mutations = {
  SET_WINDOW_WIDTH: (state, payload) => {
    state.windowWidth = payload
  },
  SET_ACTIVE_ROUTE: (state, payload) => {
    state.activeRoute = payload
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
